// extracted by mini-css-extract-plugin
export default {"instructions-list__list":"InstructionsList_instructions-list__list__yHiMw","instructions-list__item":"InstructionsList_instructions-list__item__0yJBV"};